<template>
  <nd-dialog v-model="visible" @confirm="callService">
    <div class="service-dialog">
      <div class="title">联系客服</div>
      <div class="description">{{ description }}</div>
      <div class="description1">客服电话：{{phone}}</div>
      <div class="telphone">服务时间：</div>
      <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
    </div>
  </nd-dialog>
</template>

<script>
import { mockHrefJump } from '@/assets/utils'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: '4000100008'
    },
    description: {
      type: String,
      default: '拨打客服电话进行咨询'
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    callService () {
      mockHrefJump(`tel:${this.phone}`, this.phone)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.service-dialog {
  padding-top: 10px;
  padding: 0 48px;
  padding-bottom: 80px;
  font-family: PingFangSC-Regular,PingFang SC;

  .title {
    font-size: 42px;
    height: 72px;
    line-height: 72px;
    font-family: PingFangSC-Semibold,PingFang SC;
    font-weight: 600;
  }

  .description {
    font-size: 30px;
    height: 32px;
    line-height: 32px;
    margin-top: 22px;
    font-weight: 400;
  }
  .description1{
    font-size: 30px;
    height: 32px;
    line-height: 32px;
    margin: 12px auto 12px;
    font-weight: 400;
  }

  .telphone {
    font-size: 24px;
    height: 40px;
    line-height: 40px;
    margin-top: 2px;
    font-weight: 400;
    color: @fc3;
  }
}
</style>